(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1336],{

/***/ 32468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);



var AppStoreButtonComponent = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "https://itunes.apple.com/jp/app/ecbo-cloak/id1443707795",
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/app_store.webp",
                alt: t("META.APP_STORE"),
                width: "120px",
                height: "40px"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppStoreButtonComponent);


/***/ }),

/***/ 2168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);



var GooglePlayButtonComponent = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "https://play.google.com/store/apps/details?id=io.ecbo.cloak",
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/google_play.webp",
                alt: t("META.GOOGLE_PLAY"),
                height: "37px",
                width: "125px"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GooglePlayButtonComponent);


/***/ }),

/***/ 58909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/components/commons/layouts/Layout.module.scss
var Layout_module = __webpack_require__(35195);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./src/lib/checkBreakpoint.ts
var checkBreakpoint = __webpack_require__(92122);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./src/lib/addLocalePrefix.ts
var addLocalePrefix = __webpack_require__(57467);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/providers/AuthProvider.tsx
var AuthProvider = __webpack_require__(85993);
// EXTERNAL MODULE: ./src/state/ducks/user/selectors.ts
var selectors = __webpack_require__(83552);
// EXTERNAL MODULE: ./src/hooks/common/lang.ts
var lang = __webpack_require__(16529);
// EXTERNAL MODULE: ./src/components/commons/menus/HeaderMenuComponent.module.scss
var HeaderMenuComponent_module = __webpack_require__(23014);
var HeaderMenuComponent_module_default = /*#__PURE__*/__webpack_require__.n(HeaderMenuComponent_module);
// EXTERNAL MODULE: ./src/lib/eventEmitter.ts
var eventEmitter = __webpack_require__(69043);
;// CONCATENATED MODULE: ./src/components/commons/menus/HeaderMenuComponent.tsx










// state

//hooks

// lib



var HeaderMenuComponent = function() {
    var isSigned = (0,react.useContext)(AuthProvider/* AuthContext */.V).isSigned;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, locale = ref.locale;
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors/* getUser */.P)(state);
    });
    var ref1 = (0,react.useState)(false), isShowLang = ref1[0], setIsShowLang = ref1[1];
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var langs = (0,lang/* getLangs */.Av)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (HeaderMenuComponent_module_default()).menu,
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "https://join-cloak.ecbo.io/owner",
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (HeaderMenuComponent_module_default()).ownerLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/owner_icon_blue.svg",
                                alt: t("COMMON.SIDE_MENU.PARTNER")
                            }),
                            t("COMMON.HEADER.PARTNER.REGISTER")
                        ]
                    })
                })
            }),
            !isSigned || !auth ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        onClick: function() {
                            return eventEmitter/* default.emit */.Z.emit("redirectToAuth");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/sign_in", locale),
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (HeaderMenuComponent_module_default()).menuButton,
                                children: t("COMMON.HEADER.LOGIN")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        onClick: function() {
                            return eventEmitter/* default.emit */.Z.emit("redirectToAuth");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/sign_up", locale),
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat((HeaderMenuComponent_module_default()).menuButton, " ").concat((HeaderMenuComponent_module_default()).menuButtonRegister),
                                children: t("COMMON.HEADER.REGISTER")
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/".concat(auth === null || auth === void 0 ? void 0 : auth.user_id), locale),
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (HeaderMenuComponent_module_default()).authLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (HeaderMenuComponent_module_default()).authImage,
                            src: auth.user_image_url != "" ? auth.user_image_url : "/user_no_image.webp",
                            alt: ""
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (HeaderMenuComponent_module_default()).switchLang,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    className: (HeaderMenuComponent_module_default()).switchLangBlock,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                            className: (HeaderMenuComponent_module_default()).switchLangButton,
                            onClick: function() {
                                return setIsShowLang(!isShowLang);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: (HeaderMenuComponent_module_default()).switchLangButtonIcon,
                                    src: "/language_icon.svg",
                                    alt: t("META.LANGUAGE_ICON"),
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: (HeaderMenuComponent_module_default()).switchLangButtonText,
                                    children: (0,lang/* getLangByLocale */.cd)(locale).name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/triangle_bottom_icon.svg",
                                    alt: t("META.LANGUAGE_ICON"),
                                    width: 12,
                                    height: 8
                                })
                            ]
                        }),
                        isShowLang && /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: (HeaderMenuComponent_module_default()).switchLangBox,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (HeaderMenuComponent_module_default()).switchLangList,
                                children: langs.map(function(lang, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "".concat((HeaderMenuComponent_module_default()).switchLangListItem, " ").concat(lang.slug === locale && (HeaderMenuComponent_module_default()).switchLangListItemSelected),
                                        onClick: function() {
                                            window.Intercom("update", {
                                                language_override: lang.slug
                                            });
                                            localStorage.setItem("language", lang.slug);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,addLocalePrefix/* getLangLinkProps */.WA)(lang.slug, asPath)), {
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (HeaderMenuComponent_module_default()).switchLangLink,
                                                children: lang.name
                                            })
                                        }))
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var menus_HeaderMenuComponent = (HeaderMenuComponent);

// EXTERNAL MODULE: ./src/components/commons/headers/HeaderComponent.module.scss
var HeaderComponent_module = __webpack_require__(85862);
var HeaderComponent_module_default = /*#__PURE__*/__webpack_require__.n(HeaderComponent_module);
;// CONCATENATED MODULE: ./src/components/commons/headers/index.tsx





//component


var HeaderComponent = function(param) {
    var onPressHamburgerMenu = param.onPressHamburgerMenu, isOpenMenu = param.isOpenMenu;
    var t = (0,esm/* useTranslation */.$G)().t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "".concat((HeaderComponent_module_default()).header, " ").concat(isOpenMenu ? (HeaderComponent_module_default()).openSideMenu : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (HeaderComponent_module_default()).headerBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HeaderComponent_module_default()).headerLeft,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeaderComponent_module_default()).headerLeftItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((HeaderComponent_module_default()).hamburgerMenu, " ").concat(isOpenMenu ? (HeaderComponent_module_default()).open : ""),
                                onClick: onPressHamburgerMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: isOpenMenu ? (HeaderComponent_module_default()).hideLogo : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/", locale),
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (HeaderComponent_module_default()).logo,
                                        src: "/logo.webp",
                                        alt: t("META.LOGO"),
                                        height: "30px",
                                        width: "130px"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: (HeaderComponent_module_default()).headerRight,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menus_HeaderMenuComponent, {})
                })
            ]
        })
    });
};
/* harmony default export */ var headers = (HeaderComponent);

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/lib/removeSpaceSearchParams.ts
var removeSpaceSearchParams = __webpack_require__(79926);
// EXTERNAL MODULE: ./src/components/commons/menus/SideMenuComponent.module.scss
var SideMenuComponent_module = __webpack_require__(37755);
var SideMenuComponent_module_default = /*#__PURE__*/__webpack_require__.n(SideMenuComponent_module);
;// CONCATENATED MODULE: ./src/components/commons/menus/SideMenuComponent.tsx
















//hooks



var SideMenuComponent = function(Props) {
    var user = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors/* getUser */.P)(state);
    });
    var ref = (0,react.useState)(false), isOpenAccordion = ref[0], setIsOpenAccordion = ref[1];
    var ref1 = (0,react.useContext)(AuthProvider/* AuthContext */.V), isSigned = ref1.isSigned, userId = ref1.userId;
    var ref2 = (0,router.useRouter)(), asPath = ref2.asPath, locale = ref2.locale;
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var t = (0,esm/* useTranslation */.$G)().t;
    var _onPressLogout = (0,react.useCallback)(function() {
        (0,dist.destroyCookie)(null, "jwt_token", {
            path: "/"
        });
        (0,dist.destroyCookie)(null, "user_id", {
            path: "/"
        });
        // @ts-ignore
        (0,next_auth_react.signOut)({
            redirect: false,
            callbackUrl: "/"
        });
        (0,removeSpaceSearchParams/* removeSpaceSearchParams */.r)();
        router_default().push("/");
    }, []);
    var langs = (0,lang/* getLangs */.Av)().filter(function(lang) {
        return lang.slug !== locale;
    });
    var getDefaultDateTime = (0,react.useCallback)(function(type) {
        var dateTime = "";
        if (type === "start") {
            var now = moment_default()();
            if (now.get("minutes") < 30) {
                now.set("minutes", 30);
            } else {
                now.set({
                    hours: now.get("hours") + 1,
                    minutes: 0
                });
            }
            dateTime = "".concat(now.get("hours").toString().padStart(2, "0"), ":").concat(now.get("minutes").toString().padStart(2, "0"));
        } else {
            var now1 = moment_default()();
            if (now1.get("minutes") < 30) {
                now1.set({
                    hours: now1.get("hours") + 2,
                    minutes: 30
                });
            } else {
                now1.set({
                    hours: now1.get("hours") + 3,
                    minutes: 0
                });
            }
            dateTime = "".concat(now1.get("hours").toString().padStart(2, "0"), ":").concat(now1.get("minutes").toString().padStart(2, "0"));
        }
        return dateTime;
    }, []);
    var handleSearchLocation = (0,react.useCallback)(function() {
        var path = "/locations";
        if ((router_default()).pathname === path) return;
        var query = new URLSearchParams();
        var startDateTime = getDefaultDateTime("start");
        var endDateTime = getDefaultDateTime("end");
        query.append("startDate", moment_default()().format("YYYY-MM-DD"));
        query.append("endDate", moment_default()().format("YYYY-MM-DD"));
        query.append("startDateTimeHour", startDateTime.substring(0, startDateTime.indexOf(":")));
        query.append("startDateTimeMin", startDateTime.substring(startDateTime.indexOf(":") + 1));
        query.append("endDateTimeHour", endDateTime.substring(0, endDateTime.indexOf(":")));
        query.append("endDateTimeMin", endDateTime.substring(endDateTime.indexOf(":") + 1));
        query.append("bagSize", "0");
        query.append("suitcaseSize", "1");
        query.append("lat", "35.681236");
        query.append("lon", "139.767125");
        query.append("isLocation", "false");
        router_default().push("".concat(path, "?").concat(query.toString()));
    }, [
        getDefaultDateTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SideMenuComponent_module_default()).sideMenu,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (SideMenuComponent_module_default()).menu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    onClick: function() {
                                        return handleSearchLocation();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/search_icon.svg",
                                            alt: t("META.SEARCH_ICON")
                                        }),
                                        t("COMMON.SIDE_MENU.SEARCH")
                                    ]
                                })
                            }),
                            isSigned && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/bookings?tab=current", locale),
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/booking_icon.svg",
                                                        alt: t("META.BOOKING_ICON")
                                                    }),
                                                    t("COMMON.SIDE_MENU.BOOKING_LIST")
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/".concat(userId), locale),
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/setting_icon.svg",
                                                        alt: t("META.SETTING_ICON")
                                                    }),
                                                    t("COMMON.SIDE_MENU.ACCOUNT"),
                                                    user && !(user === null || user === void 0 ? void 0 : user.phone_verified) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/warning.png",
                                                        alt: "",
                                                        className: (SideMenuComponent_module_default()).warningIcon
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "https://intercom.help/ecbocloak",
                                    passHref: true,
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/faq_icon.svg",
                                                alt: t("META.FAQ_ICON")
                                            }),
                                            t("COMMON.SIDE_MENU.QUESTION")
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (SideMenuComponent_module_default()).openIntercom,
                                onClick: function() {
                                    return window.Intercom("showMessages");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/contact_icon.svg",
                                        alt: t("META.CONTACT_ICON")
                                    }),
                                    t("COMMON.SIDE_MENU.CONTACT")
                                ]
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: (SideMenuComponent_module_default()).accordionMenu,
                                        onClick: function() {
                                            return setIsOpenAccordion(!isOpenAccordion);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (SideMenuComponent_module_default()).accordionMenuLangIcon,
                                                src: "/language_icon.svg",
                                                alt: t("META.LANGUAGE_ICON"),
                                                height: 24,
                                                width: 24
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SideMenuComponent_module_default()).accordionMenuTitle,
                                                children: (0,lang/* getLangByLocale */.cd)(locale).name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "".concat((SideMenuComponent_module_default()).accordionMenuArrowIcon, " ").concat(isOpenAccordion && (SideMenuComponent_module_default()).accordionMenuArrowIconActive),
                                                src: "/arrow_bottom_black_02.svg",
                                                alt: t("META.LANGUAGE_ICON"),
                                                width: 24,
                                                height: 24
                                            })
                                        ]
                                    }),
                                    isOpenAccordion && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (SideMenuComponent_module_default()).subMenu,
                                        children: langs.map(function(lang, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return localStorage.setItem("language", lang.slug);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,addLocalePrefix/* getLangLinkProps */.WA)(lang.slug, asPath)), {
                                                    passHref: true,
                                                    legacyBehavior: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (SideMenuComponent_module_default()).language,
                                                        children: lang.name
                                                    })
                                                }))
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "".concat((SideMenuComponent_module_default()).menu, " ").concat((SideMenuComponent_module_default()).menuPartner),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat("https://stg-auth.ecbo.io", "/owners/sign_in"),
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/owner_icon_black.svg",
                                                    alt: t("META.PARTNER_ICON")
                                                }),
                                                t("COMMON.SIDE_MENU.PARTNER"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (SideMenuComponent_module_default()).menuArrowIcon,
                                                    src: "/arrow_bottom_black_02.svg",
                                                    alt: t("META.ARROW_ICON"),
                                                    width: 24,
                                                    height: 24
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (SideMenuComponent_module_default()).buttonMenuList,
                                children: isSigned ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (SideMenuComponent_module_default()).buttonMenuListItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (SideMenuComponent_module_default()).buttonMenu,
                                        type: "button",
                                        onClick: _onPressLogout,
                                        children: t("COMMON.HEADER.LOGOUT")
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return eventEmitter/* default.emit */.Z.emit("redirectToAuth");
                                            },
                                            className: (SideMenuComponent_module_default()).buttonMenuListItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/sign_up", locale),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "".concat((SideMenuComponent_module_default()).buttonMenu, " ").concat((SideMenuComponent_module_default()).buttonMenuActive),
                                                    children: t("COMMON.HEADER.REGISTER")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return eventEmitter/* default.emit */.Z.emit("redirectToAuth");
                                            },
                                            className: (SideMenuComponent_module_default()).buttonMenuListItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/users/sign_in", locale),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (SideMenuComponent_module_default()).buttonMenu,
                                                    children: t("COMMON.HEADER.LOGIN")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (SideMenuComponent_module_default()).buttonMenuListItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://join-cloak.ecbo.io/owner",
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (SideMenuComponent_module_default()).buttonMenu,
                                                    children: t("TOP.OWNER.REGISTER")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SideMenuComponent_module_default()).ownerMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat("https://stg-auth.ecbo.io", "/owners/sign_in"),
                            legacyBehavior: true,
                            children: t("COMMON.SIDE_MENU.PARTNER")
                        })
                    }),
                    isSigned && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SideMenuComponent_module_default()).logout,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (SideMenuComponent_module_default()).logoutButton,
                            type: "button",
                            onClick: _onPressLogout,
                            children: t("COMMON.HEADER.LOGOUT")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var menus_SideMenuComponent = (SideMenuComponent);

// EXTERNAL MODULE: ./src/components/commons/footers/FooterComponent.module.scss
var FooterComponent_module = __webpack_require__(21490);
var FooterComponent_module_default = /*#__PURE__*/__webpack_require__.n(FooterComponent_module);
// EXTERNAL MODULE: ./src/components/buttons/AppStoreButtonComponent.tsx
var AppStoreButtonComponent = __webpack_require__(32468);
// EXTERNAL MODULE: ./src/components/buttons/GooglePlayButtonComponent.tsx
var GooglePlayButtonComponent = __webpack_require__(2168);
// EXTERNAL MODULE: ./src/components/icons/AccordionIconComponent.tsx
var AccordionIconComponent = __webpack_require__(6565);
;// CONCATENATED MODULE: ./src/components/commons/footers/index.tsx











var BOOKING_CTA_DETAIL_PATHS = [
    "/space/[...slug]",
    "/spaces/[...id]",
    "/locker/[id]",
    "/pudo/[id]", 
];
var FooterComponent = function() {
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var ref = (0,react.useState)({
        open: false,
        target: ""
    }), isOpenAccordion = ref[0], setIsOpenAccordion = ref[1];
    var ref1 = (0,esm/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,router.useRouter)(), locale = ref2.locale, pathname = ref2.pathname;
    // AndroidのSPで発生する固定ボタン下部の空白への対応として、予約CTAがある詳細ページでFooterを前面に表示
    var shouldRaiseFooterAboveBookingCta = isMobile && BOOKING_CTA_DETAIL_PATHS.includes(pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "".concat((FooterComponent_module_default()).footer, " ").concat(shouldRaiseFooterAboveBookingCta ? (FooterComponent_module_default()).footerAboveBookingCta : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FooterComponent_module_default()).footerHeading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/logo_footer.webp",
                    alt: t("META.LOGO_FOOTER"),
                    width: "161px",
                    height: "36px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterComponent_module_default()).footerContents,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterComponent_module_default()).list,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listHeading,
                                onClick: function() {
                                    return isMobile ? setIsOpenAccordion(function(prev) {
                                        return {
                                            open: prev.target === "service" ? !prev.open : true,
                                            target: "service"
                                        };
                                    }) : "";
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).listHeadingTitle,
                                        children: t("FOOTER.SERVICE.ABOUT")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).accordion,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionIconComponent/* default */.Z, {
                                            isOpenAccordion: isOpenAccordion.open && isOpenAccordion.target === "service",
                                            position: "footer"
                                        })
                                    })
                                ]
                            }),
                            (!isMobile || isOpenAccordion.open && isOpenAccordion.target === "service") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://intercom.help/ecbocloak/".concat(i18n.language),
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.SERVICE.QUESTION")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).openIntercom,
                                        onClick: function() {
                                            window.Intercom("update", {
                                                language_override: i18n.language
                                            });
                                            window.Intercom("showMessages");
                                        },
                                        children: t("FOOTER.SERVICE.CONTACT")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://assets.ecbo.io/",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.SERVICE.ASSET")
                                            })
                                        })
                                    }),
                                    locale !== "en" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://join-cloak.ecbo.io/owner".concat(locale !== "ja" ? "/".concat(locale) : ""),
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.SERVICE.OWNER_LP")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterComponent_module_default()).list,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listHeading,
                                onClick: function() {
                                    return isMobile ? setIsOpenAccordion(function(prev) {
                                        return {
                                            open: prev.target === "company" ? !prev.open : true,
                                            target: "company"
                                        };
                                    }) : "";
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).listHeadingTitle,
                                        children: t("FOOTER.COMPANY.ABOUT")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).accordion,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionIconComponent/* default */.Z, {
                                            isOpenAccordion: isOpenAccordion.open && isOpenAccordion.target === "company",
                                            position: "footer"
                                        })
                                    })
                                ]
                            }),
                            (!isMobile || isOpenAccordion.open && isOpenAccordion.target === "company") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://ecbo.io/",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.COMPANY.SITE")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://ecbo.io/about/#:~:text=CEO%20%E5%B7%A5%E8%97%A4%20%E6%85%8E%E4%B8%80-,COMPANY,-%E4%BC%9A%E7%A4%BE%E6%A6%82%E8%A6%81",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.COMPANY.INFOMATION")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://ecbo.io/careers-2/",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.COMPANY.CAREER")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterComponent_module_default()).list,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listHeading,
                                onClick: function() {
                                    return isMobile ? setIsOpenAccordion(function(prev) {
                                        return {
                                            open: prev.target === "term" ? !prev.open : true,
                                            target: "term"
                                        };
                                    }) : "";
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).listHeadingTitle,
                                        children: t("FOOTER.TERM.ABOUT")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).accordion,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionIconComponent/* default */.Z, {
                                            isOpenAccordion: isOpenAccordion.open && isOpenAccordion.target === "term",
                                            position: "footer"
                                        })
                                    })
                                ]
                            }),
                            (!isMobile || isOpenAccordion.open && isOpenAccordion.target === "term") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/terms/user/space", locale),
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.TERM.INFOMATION")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://cloak.ecbo.io/".concat(locale !== "ja" ? "".concat(locale) : "ja", "/privacy"),
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.TERM.PRIVACY")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://cloak.ecbo.io/".concat(locale !== "ja" ? "".concat(locale) : "ja", "/legal"),
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("FOOTER.TERM.LEGAL")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterComponent_module_default()).listOther,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (FooterComponent_module_default()).listOtherHeading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (FooterComponent_module_default()).listOtherHeadingTitle,
                                    children: t("FOOTER.SNS.ABOUT")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listOtherSnsItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).snsIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/".concat(locale == "zh-TW" ? "ecbocloakTC" : "ecbocloak"),
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/facebook_icon.svg",
                                                    alt: t("META.FACEBOOK_ICON"),
                                                    height: 24,
                                                    width: 24
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).snsIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://twitter.com/ecbocloak",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/twitter_icon.svg",
                                                    alt: t("META.TWITTER_ICON"),
                                                    height: 24,
                                                    width: 24
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).snsIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.instagram.com/ecbocloak/",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/instagram_icon.svg",
                                                    alt: t("META.INSTAGRAM_ICON"),
                                                    height: 24,
                                                    width: 24
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (FooterComponent_module_default()).snsIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.youtube.com/channel/UCUTh2d0BlStbzEIaA4iZ6Qg/videos",
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/youtube_icon.svg",
                                                    alt: t("META.YOUTUBE_ICON"),
                                                    height: 24,
                                                    width: 24
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (FooterComponent_module_default()).listOtherStoreItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreButtonComponent/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePlayButtonComponent/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footers = (FooterComponent);

;// CONCATENATED MODULE: ./src/components/commons/layouts/Layout.tsx








var Layout = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    var isMobile = (0,checkBreakpoint/* default */.Z)().isMobile;
    var ref = (0,react.useState)(false), isOpenMenu = ref[0], setIsOpenMenu = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headers, {
                onPressHamburgerMenu: function() {
                    return setIsOpenMenu(!isOpenMenu);
                },
                isOpenMenu: isOpenMenu
            }),
            isOpenMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(menus_SideMenuComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "".concat((Layout_module_default()).main, " ").concat(isOpenMenu ? (Layout_module_default()).openMenu : ""),
                children: children
            }),
            pathname in {
                "/": "/",
                "/space/[...slug]": "/space/[...slug]",
                "/spaces/[...id]": "/spaces/[...id]",
                "/[country]": "/[country]",
                "/[country]/city/[...slug]": "/[country]/city/[...slug]",
                "/users/delete": "/users/delete",
                "/locker/[id]": "/locker/[id]",
                "/pudo/[id]": "/pudo/[id]"
            } && /*#__PURE__*/ (0,jsx_runtime.jsx)(footers, {})
        ]
    });
};
/* harmony default export */ var layouts_Layout = (Layout);


/***/ }),

/***/ 6565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39617);
/* harmony import */ var _AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var AccordionIconComponent = function(param) {
    var isOpenAccordion = param.isOpenAccordion, position = param.position, accordionStyle = param.accordionStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().accordionIcon), " ").concat(isOpenAccordion ? (_AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().open) : (_AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().close), " ").concat(position ? (_AccordionIconComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[position] : "", " ").concat(accordionStyle)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionIconComponent);


/***/ }),

/***/ 16529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getLangs; },
/* harmony export */   "cd": function() { return /* binding */ getLangByLocale; },
/* harmony export */   "kB": function() { return /* binding */ getAreaName; },
/* harmony export */   "mC": function() { return /* binding */ replaceLocale; }
/* harmony export */ });
/**
 * エリア名を取得する
 * @param locale
 * @param prefecture
 * @returns
 */ var getAreaName = function(locale, prefecture) {
    return prefecture.area_name;
};
/**
 * 言語一覧を取得する
 * @returns Lang[] 言語一覧
 */ function getLangs() {
    return [
        {
            slug: "ja",
            name: "日本語"
        },
        {
            slug: "en",
            name: "English"
        },
        {
            slug: "zh-TW",
            name: "繁體中文"
        }, 
    ];
}
/**
 * 選択した言語キーを条件に言語データを取得する
 * @param locale string 選択した言語のキー
 * @returns Lang 選択した言語のデータ
 */ function getLangByLocale(locale) {
    var langs = getLangs();
    var lang = langs[0];
    langs.map(function(l) {
        if (l.slug === locale) {
            lang = l;
        }
    });
    return lang;
}
/**
 * localeを置換する
 * @param locale
 * @returns
 */ function replaceLocale(locale) {
    return locale.replace("zh_tw", "zh-TW");
}


/***/ }),

/***/ 92122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCheckBreakpoint; },
/* harmony export */   "j": function() { return /* binding */ responsive; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);


var responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 992
        },
        items: 3
    },
    tablet: {
        breakpoint: {
            max: 991,
            min: 576
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 575,
            min: 0
        },
        items: 1
    }
};
function useCheckBreakpoint() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "992px"
    });
    var isTablet = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "576px",
        maxWidth: "991px"
    });
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "575px"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) setIsClient(true);
    }, []);
    return {
        isDesktop: isClient ? isDesktop : true,
        isTablet: isClient ? isTablet : false,
        isMobile: isClient ? isMobile : false
    };
}


/***/ }),

/***/ 69043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54146);

var eventEmitter = new eventemitter3__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z();
/* harmony default export */ __webpack_exports__["Z"] = (eventEmitter);


/***/ }),

/***/ 22923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


var Meta = function(param) {
    var title = param.title, description = param.description, image = param.image, url = param.url, isCrawling = param.isCrawling, isCrawlingNoIndex = param.isCrawlingNoIndex, jsonLd = param.jsonLd;
    // URLを修正する
    url = url === null || url === void 0 ? void 0 : url.replace("/zh_tw", "/zh-TW");
    var langs = {
        ja: "ja",
        en: "en",
        "zh-TW": "zh-Hant"
    };
    // 本番環境外の場合は強制的にnoindex
    if (true) {
        isCrawling = true;
    }
    /**
   * 言語コードを取得する
   * @returns
   */ var getAlternateTag = function(lang) {
        // let langCode: string = 'ja'
        var langUrl = "".concat("https://stg-cloak.ecbo.io").concat(url);
        // replace
        langUrl = langUrl.replace("/ja", "/".concat(lang)).replace("/en", "/".concat(lang)).replace("/zh-TW", "/".concat(lang));
        return {
            langCode: langs[lang],
            langUrl: langUrl
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: image ? "summary" : "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@ecbocloak"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat("https://stg-cloak.ecbo.io").concat(url)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image ? image : "".concat("https://stg-cloak.ecbo.io", "/ogp.png")
            }),
            isCrawlingNoIndex && !isCrawling && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            isCrawling && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "".concat("https://stg-cloak.ecbo.io").concat(url)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "".concat("https://stg-cloak.ecbo.io", "/favicon.ico")
            }),
            Object.keys(langs).map(function(lang) {
                var ref = getAlternateTag(lang), langCode = ref.langCode, langUrl = ref.langUrl;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    hrefLang: langCode,
                    href: langUrl
                }, lang);
            }),
            jsonLd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: jsonLd
                }
            }, "json-ld")
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Meta);


/***/ }),

/***/ 79926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ removeSpaceSearchParams; }
/* harmony export */ });
/**
 * LocalStorage
 * search paramsを削除
 */ function removeSpaceSearchParams() {
    localStorage.removeItem("search_params");
}


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getCreditCard; },
/* harmony export */   "P": function() { return /* binding */ getUser; }
/* harmony export */ });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getUser = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(param) {
    var user = param.user;
    return user.data;
}, function(users) {
    return users.result;
});
var getCreditCard = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(param) {
    var creditCard = param.creditCard;
    return creditCard.data;
}, function(creditCard) {
    return creditCard.result;
});


/***/ }),

/***/ 21490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","footer":"FooterComponent_footer__qXS2J","footerHeading":"FooterComponent_footerHeading__Al3pv","footerContents":"FooterComponent_footerContents__GaKQW","list":"FooterComponent_list__MV44R","listHeading":"FooterComponent_listHeading__NblLh","listHeadingTitle":"FooterComponent_listHeadingTitle__RpCjU","listItems":"FooterComponent_listItems__ixGvE","listOtherHeading":"FooterComponent_listOtherHeading__BcrB6","listOtherHeadingTitle":"FooterComponent_listOtherHeadingTitle__iOXUA","listOtherSnsItems":"FooterComponent_listOtherSnsItems___mN0v","listOtherStoreItems":"FooterComponent_listOtherStoreItems__UyPNU","openIntercom":"FooterComponent_openIntercom__fII1V","accordion":"FooterComponent_accordion__h_tn_","snsIcon":"FooterComponent_snsIcon__Y9DAU","footerAboveBookingCta":"FooterComponent_footerAboveBookingCta__HqPkB","listOther":"FooterComponent_listOther__8OKJY"};

/***/ }),

/***/ 85862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","header":"HeaderComponent_header___vVZb","headerBox":"HeaderComponent_headerBox__IQ8fQ","headerLeftItem":"HeaderComponent_headerLeftItem__xDTDZ","logo":"HeaderComponent_logo__R8uDl","hamburgerMenu":"HeaderComponent_hamburgerMenu__h26c6","open":"HeaderComponent_open__3j1nj","headerLeft":"HeaderComponent_headerLeft__QpkaT","headerRight":"HeaderComponent_headerRight__CRdjj","openSideMenu":"HeaderComponent_openSideMenu__HK1kg","hideLogo":"HeaderComponent_hideLogo__cX0Dt","warningIcon":"HeaderComponent_warningIcon__vJT2U"};

/***/ }),

/***/ 35195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","main":"Layout_main__kWZt4","openMenu":"Layout_openMenu__UA_H7"};

/***/ }),

/***/ 23014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","menu":"HeaderMenuComponent_menu__ZcvbF","menuButton":"HeaderMenuComponent_menuButton__LGe5t","menuButtonRegister":"HeaderMenuComponent_menuButtonRegister__43EK6","ownerLink":"HeaderMenuComponent_ownerLink__bpFzb","switchLang":"HeaderMenuComponent_switchLang__w5scB","switchLangBlock":"HeaderMenuComponent_switchLangBlock__O2uSu","switchLangButton":"HeaderMenuComponent_switchLangButton__HF5eX","switchLangButtonText":"HeaderMenuComponent_switchLangButtonText__CNkhC","switchLangButtonIcon":"HeaderMenuComponent_switchLangButtonIcon__Al89l","switchLangBox":"HeaderMenuComponent_switchLangBox__oYHJg","switchLangListItem":"HeaderMenuComponent_switchLangListItem__sNv7j","switchLangListItemSelected":"HeaderMenuComponent_switchLangListItemSelected__eYmT5","switchLangLink":"HeaderMenuComponent_switchLangLink__EU7bq","authImage":"HeaderMenuComponent_authImage__1Wxfo","authLink":"HeaderMenuComponent_authLink__v7L_b"};

/***/ }),

/***/ 37755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","sideMenu":"SideMenuComponent_sideMenu__u5i55","menu":"SideMenuComponent_menu__IYYyf","buttonMenu":"SideMenuComponent_buttonMenu__da0Hj","buttonMenuActive":"SideMenuComponent_buttonMenuActive__RvcQ5","buttonMenuList":"SideMenuComponent_buttonMenuList___qa89","ownerMenu":"SideMenuComponent_ownerMenu__1n632","openIntercom":"SideMenuComponent_openIntercom__5GPzw","logout":"SideMenuComponent_logout__QOoW7","logoutButton":"SideMenuComponent_logoutButton__VaS7R","accordionMenu":"SideMenuComponent_accordionMenu__nJ6r_","accordionMenuTitle":"SideMenuComponent_accordionMenuTitle__k90_n","subMenu":"SideMenuComponent_subMenu__7Jkfz","language":"SideMenuComponent_language__w_4Ce","sideMenuShowSmartBanner":"SideMenuComponent_sideMenuShowSmartBanner__b8t2U","menuArrowIcon":"SideMenuComponent_menuArrowIcon__ZDV_E","menuPartner":"SideMenuComponent_menuPartner__onv0B","accordionMenuLangIcon":"SideMenuComponent_accordionMenuLangIcon__TXItz","accordionMenuArrowIcon":"SideMenuComponent_accordionMenuArrowIcon__WQmAB","accordionMenuArrowIconActive":"SideMenuComponent_accordionMenuArrowIconActive__eMr9Q","headerMenu":"SideMenuComponent_headerMenu__4l9ZF","warningIcon":"SideMenuComponent_warningIcon__Y5yGp"};

/***/ }),

/***/ 39617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","accordionIcon":"AccordionIconComponent_accordionIcon__H7iK7","close":"AccordionIconComponent_close__dUgAc","open":"AccordionIconComponent_open__CAyHW","footer":"AccordionIconComponent_footer__RU3Rr"};

/***/ })

}]);